/**
 * The extra-small tool button (`size="xs"`): a line of quiet tools under a drawing (the viewer's
 * footer). Both themes style it from here, since the footer is shared by classic and Design v2.
 */
declare module "@mui/joy/Button" {
    interface ButtonPropsSizeOverrides {
        xs: true;
    }
}

declare module "@mui/joy/IconButton" {
    interface IconButtonPropsSizeOverrides {
        xs: true;
    }
}

/** The extra-small control's height: the footer's buttons, pager arrows and page field. */
export const XS_CONTROL = "24px";

type XsTheme = { vars: { palette: { text: { secondary: string; primary: string } } } };

/** Joy styles only its own sizes, so `xs` sets its whole box: Button and IconButton alike. */
function xsButton(theme: XsTheme) {
    return {
        "--Button-gap": "5px",
        "--Icon-fontSize": "16px",
        minHeight: XS_CONTROL,
        minWidth: XS_CONTROL,
        paddingBlock: 0,
        paddingInline: "8px",
        borderRadius: "var(--radius-xs)",
        fontSize: "var(--type-caption)",
        fontWeight: 500,
        color: theme.vars.palette.text.secondary,
        "--Icon-color": "currentColor",
        "&:hover, &:active": { color: theme.vars.palette.text.primary },
    } as const;
}

/** A Button's `xs` box, for its theme's root override; nothing for any other size. */
export function xsButtonRoot(size: string | undefined, theme: XsTheme) {
    return size === "xs" ? xsButton(theme) : {};
}

/** An IconButton's `xs` box: the button's, square. */
export function xsIconButtonRoot(size: string | undefined, theme: XsTheme) {
    return size === "xs" ? { ...xsButton(theme), paddingInline: 0 } : {};
}
